export default "__VITE_ASSET__DNt55eGF__"